import React from "react";
import "./styles.less";

import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { ZeroTrustBanner } from "./ZeroBanner";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { SolutionCustomer } from "../../blocks/solution-customer";
import { ZeroAdvantage } from "./ZeroAdvantage";
import { ZeroIdaas } from "./ZeroIdaas";
import { ZeroSecurity } from "./ZeroSecurity";
import { ZeroCompliance } from "./ZeroCompliance";
import { ZeroOther } from "./ZeroOther";

export const ZeroTrustPage = () => {
  const { t } = useTranslation();
  const banner = {
    title: t("solution.auth0.banner.title"),
    subtitle: t("solution.auth0.banner.description"),
    background: "solution-auth0-banner.png",
    link: "https://www.authing.cn/authingform?fromTag=Auth0方案咨询",
    download:
      "/authingform?fromTag=Auth0&download=https://host.huiju.cool/file/6680150219df4a278ac8eacd64c49111",
  };

  return (
    <div className="zero-trust-page">
      <Helmet>
        <title>零信任身份认证解决方案，保护企业身份安全｜Authing</title>
      </Helmet>
      <Header mode="light" hasNotice />
      <ZeroTrustBanner {...banner} />
      <ZeroAdvantage />
      <ZeroIdaas />
      <ZeroSecurity />
      <ZeroCompliance />
      <div style={{ paddingTop: 80 }}>
        <SolutionCustomer />
      </div>
      <ZeroOther />
      <Footer />
    </div>
  );
};
